import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles/global.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom'; 

// 禁用手势导航
document.addEventListener('touchstart', (e) => {
  if (e.touches.length > 1) {
    e.preventDefault();
  }
}, { passive: false });

document.addEventListener('touchmove', (e) => {
  if (e.touches.length > 1) {
    e.preventDefault();
  }
}, { passive: false });

// 创建加载提示 DOM
const loadingHtml = `
  <div id="loading-wrapper">
    <div id="loading-text">
      系统正在初始化<span class="loading-dots"></span>
    </div>
  </div>
`;
document.body.insertAdjacentHTML('afterbegin', loadingHtml);

const container = document.getElementById('root');
const root = createRoot(container!);

// 在应用加载完成后移除加载提示
const removeLoading = () => {
  const loadingElement = document.getElementById('loading-wrapper');
  if (loadingElement) {
    loadingElement.style.opacity = '0';
    loadingElement.style.transition = 'opacity 0.5s';
    setTimeout(() => {
      loadingElement.remove();
    }, 500);
  }
};

root.render(
  <Suspense fallback={null}>
    <BrowserRouter>  
      <App onLoad={removeLoading}/> 
    </BrowserRouter>
  </Suspense>
);